<template>
  <div class="w-100">
    <div class="d-flex justify-content-start">
      <span class="align-middle fsize-16">Product Status</span>
      <select class="ms-3 form-select fw-bold" style="width: 13%;" v-model="selected">
        <option v-for="(data) in listData" :key="data.id" :value="data.value">{{`${data.label} ${selected === data.value ? `(${count})`: ''}`}}</option>
      </select>
    </div>
    <!-- FOR TABLEBASIC RERENDER EVERY STATUS CHANGED -->
    <Product v-if="selected == 'All'" :productStatus="selected"  @getCount="handleCount"/>
    <Product v-if="selected == 'LiveInStock'" :productStatus="selected"  @getCount="handleCount"/>
    <Product v-else-if="selected == 'LiveOutOfStock'" :productStatus="selected"  @getCount="handleCount"/>
    <Product v-else-if="selected == 'NeedReview'" :productStatus="selected"  @getCount="handleCount"/>
    <Product v-else-if="selected == 'Archive'" :productStatus="selected"  @getCount="handleCount"/>
    <Product v-else-if="selected == 'Suspended'" :productStatus="selected"  @getCount="handleCount"/>
  </div>
</template>

<script>

  import Product from "./Product.vue"

  export default {
    components: {
      Product
    },
    data() {
      return {
        selected: "All",
        listData: [
          { value: "All", id: 1, label : "All" },
          { value: "LiveInStock", id: 2, label : "Live In Stock" },
          { value: "LiveOutOfStock", id: 3, label : "Live Out Of Stock" },
          { value: "Archive", id: 4, label : "Archive" },
          { value: "Suspended", id: 5, label : "Suspended" },
          { value: "NeedReview", id: 6, label : "NeedReview" },
        ],
        count: 0
      };
    },
    
    watch: {
      selected(value) {
        this.count = 0
        this.$router.push(`/products/all-product?status=${value}`)
      },
      '$route': {
        handler: function(value) {
          if(value.path === "/products/all-product" && value.query.status){
              this.selected = value.query.status
          }
        },
        deep: true,
      }
    },

    methods:{
      handleCount(count){
        this.count = count
      }
    },
    
    created() {
      if (this.$route.query.status){
        this.selected = this.$route.query.status
      }else{
        this.$router.push(`/products/all-product?status=${this.selected}`)
      }
    }
  };
</script>


<style scoped>
  .form-control {
    width: 150px;
  }
</style>